import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ArrowRight } from 'lucide-react';
const faqs = [{
  q: '¿Esto es para mí si empiezo desde cero?',
  a: 'Sí. Está armado para principiantes: vas con un paso a paso claro para pasar de "no sé por dónde empezar" a tener todo listo para vender.'
}, {
  q: '¿Necesito experiencia en ventas o marketing?',
  a: 'No. Te damos la estructura y el proceso para que sepas qué hacer y en qué orden, sin depender de "talento" o improvisación.'
}, {
  q: '¿Cuánto dinero necesito para empezar?',
  a: 'Con $100–$150 USD para anuncios es suficiente para iniciar pruebas.'
}, {
  q: '¿Cuánto tiempo al día tengo que dedicarle?',
  a: 'Con 1 a 2 horas al día podés avanzar bien. Si le metés más tiempo, vas a acelerar el proceso.'
}, {
  q: '¿En cuánto tiempo puedo ver mis primeras ventas?',
  a: 'Depende de tu ejecución y del mercado, pero la idea es que puedas lanzar rápido y empezar a validar con datos lo antes posible.'
}, {
  q: '¿Me ayudan a elegir un producto ganador?',
  a: 'Sí. Te enseñamos cómo identificar demanda real y seleccionar productos con criterio, para que no elijas "por intuición".'
}, {
  q: '¿Me dan proveedores o me enseñan a conseguirlos?',
  a: 'Te enseñamos el método para conseguirlos y evaluarlos bien (calidad, tiempos, stock y condiciones), para que no dependas de un solo contacto.'
}, {
  q: '¿Puedo hacerlo en mi país (México/Colombia/Perú/Chile/Argentina)?',
  a: 'Sí. El sistema está pensado para LATAM, adaptando la operación a lo que funciona en la región.'
}, {
  q: '¿Cómo cobro si vendo (transferencia, pasarela, contra entrega)?',
  a: 'Vas a poder cobrar con los métodos disponibles en tu país: transferencia, pasarelas y/o contra entrega, según tu estrategia y mercado.'
}, {
  q: '¿Tengo que crear una tienda desde cero?',
  a: 'Te guiamos para armarla desde cero si no tenés, o para optimizar la que ya tenés si ya empezaste antes.'
}, {
  q: '¿Hay acompañamiento real o es solo un curso grabado?',
  a: 'Hay acompañamiento: no es solo mirar videos. Tenés guía para ejecutar y soporte para corregir y avanzar.'
}, {
  q: '¿Qué pasa si me trabo? ¿Dónde pregunto y en cuánto responden?',
  a: 'Preguntás por los canales de soporte del programa y te destrabamos con pasos concretos para que sigas avanzando (no te quedás solo).'
}, {
  q: '¿Las sesiones en vivo quedan grabadas?',
  a: 'Sí. Si no podés estar en vivo, las ves grabadas y seguís el plan a tu ritmo.'
}, {
  q: '¿Cuánto tiempo tengo acceso al contenido y actualizaciones?',
  a: 'Tenés 3 meses de acceso a todo el contenido y al acompañamiento. Es tiempo suficiente para implementar el sistema y empezar a ver resultados si ejecutás.'
}, {
  q: '¿Qué pasa si no tengo redes o audiencia?',
  a: 'No pasa nada. No necesitás ser influencer ni mostrar tu rostro. Vendemos con publicidad en Meta Ads usando páginas con el nombre de tu tienda, sin depender de una audiencia previa.'
}, {
  q: '¿Puedo hacerlo si trabajo y tengo poco tiempo?',
  a: 'Sí. El sistema está pensado para ejecutarlo por bloques, avanzando cada día sin necesidad de estar todo el día conectado.'
}, {
  q: '¿Voy a saber exactamente qué hacer cada día (paso a paso)?',
  a: 'Sí. Tenés una ruta operativa con tareas claras para ejecutar en orden y no perderte.'
}, {
  q: '¿Qué diferencia a este programa de ver videos en YouTube?',
  a: 'Acá tenés un método completo, en orden, con acompañamiento para corregir errores rápido, en vez de probar cosas sueltas sin rumbo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-12">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="text-center mb-12" data-id="element-13">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white" data-id="element-14">
          Preguntas Frecuentes
        </h2>
      </motion.div>

      <div className="space-y-3" data-id="element-15">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-[#0F0F0F] border border-[#1F1F1F] rounded-xl overflow-hidden" data-id="element-16">
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/[0.03] transition-colors duration-200 group" data-id="element-17">
                <span className="font-semibold text-white text-base sm:text-lg pr-4 group-hover:text-gray-100" data-id="element-18">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="flex-shrink-0" data-id="element-19">
                  <ChevronDown className="w-5 h-5 text-primary" data-id="element-20" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-21">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-22">
                    <div className="px-6 pb-5 text-gray-400 font-medium leading-relaxed border-t border-[#1F1F1F] pt-4" data-id="element-23">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="mt-12 text-center" data-id="element-24">
        <motion.a href="#precio" animate={{
        boxShadow: ['0 0 20px -5px rgba(255,31,31,0.5)', '0 0 50px 5px rgba(255,31,31,0.7)', '0 0 20px -5px rgba(255,31,31,0.5)']
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-5 text-lg font-bold text-white bg-primary hover:bg-primaryHover rounded-xl transition-all duration-200 transform hover:scale-[1.02]" data-id="element-25">
          SÍ, QUIERO ACTIVAR MI MÁQUINA DE VENTAS
          <ArrowRight className="w-6 h-6" data-id="element-26" />
        </motion.a>
      </motion.div>
    </section>;
}